import APP from 'src/main.js'
import Person from './Person.js'
class Employee extends Person {
  get current_clients(){
    return this.current_primary_relations.map(rel => rel.client)
  }
  get client_entities(){
    return [... new Set(this.current_clients.map(cli => cli.entities).flat(1))]
  }

  get advisor_for(){
    return this.constructor.employeeStore.person_consultants.filter(rel => rel.consultant_id === this.id)
  }

  get advisor_for_people(){
    return this.advisor_for.map(rel => rel.person)
  }

  get advisor_for_entities(){
    return this.advisor_for.map(rel => rel.person.entities).flat(1)

  }
}
export default Employee
